import { ANNUAL_CROSS_TOPIC_DETAIL_CAPTURE_CSS } from './annualCrossTopicDetailCaptureCss';

/** html2canvas 오프스크린 캡처용 — 범교과 운영계획(주제별 다중 표) */
export const ANNUAL_CROSS_TOPIC_PROGRAM_PLAN_CAPTURE_CSS = `${ANNUAL_CROSS_TOPIC_DETAIL_CAPTURE_CSS}
.cp-annual-cross-topic-program-plan-doc-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 12px;
  margin: 0 0 14px;
  font-size: 20px !important;
  font-weight: 700;
  text-align: center;
  color: #111;
  line-height: 1.35 !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
}
.cp-annual-cross-topic-program-plan-doc-title-text {
  color: #111;
  font-size: 20px !important;
  line-height: 1.35 !important;
}
.cp-annual-cross-topic-program-plan-group {
  margin: 0 0 18px;
}
.cp-annual-cross-topic-program-plan-group:last-child {
  margin-bottom: 0;
}
.cp-annual-cross-topic-program-plan-group-topic {
  margin-bottom: 6px !important;
}
`;
